export const PAGE_BLOCK_TYPES = {
  DRAFTJS: 'draftjs',
  TINYMCE: 'tinymce',
  COMMITMENT: 'commitment',
  COMMITMENT_CHECK: 'commitment-check'
}
